import React from 'react';
import {AnomalyDetection} from 'prophesier/dist/wrapper/index-with-deps-react.min.js';
import Box from 'grommet/components/Box';
import Label from 'grommet/components/Label';
import NumberInput from 'grommet/components/NumberInput';
import Publish from "./utils/Publish";

class Anomaly extends React.Component {
    constructor() {
        super();
        this.state = { 
            time: null,
            showcomponent: false,
            finalResult: null,
            steps: 4,
            epsilon: 0.01, 
            emailAlert: false,
            model: null,
            published: false,
            spinningFlag: false,
            id: ""
        }
        this._onpublish = this._onpublish.bind(this)
    }
    componentDidMount() {
        this.setState({showcomponent: true})
    }
    _onpublish(event) {
       
       const {finalResultMeanVar,
        steps,
        epsilon,
        minperiod
    } = event.detail;
        const model = {finalResultMeanVar, epsilon, steps, minperiod, mla: "anomaly"}
        this.setState({emailAlert: true, model})
        //{"finalResultMeanVar":[{"count":16,"mean":1.9375,"variance":0.4625},{"count":16,"mean":3.875,"variance":0.5166666666666667},{"count":16,"mean":6.71875,"variance":1.1989583333333333},{"count":15,"mean":9.133333206176758,"variance":0.23423}],"epsilon":0.01,"steps":4,"minperiod":"6hh"}
        //Save in Google Sheet
    }
    _onSubmit(e) {
        this.setState({emailAlert: false})
        
    }
    _onChange(event) {       
        this.setState({ finalDataObjectPredict: event.target.value})
    }
    _onChangeOptions(field, event) {
        const numericValue = parseInt(event.target.value)
        switch(field) {
            case "steps":
                this.setState({ steps: numericValue})
                break;
            case "epsilon":
                this.setState({ epsilon: event.target.value})
                break;
        }
    }
    parseObject(dataObject) {
        let dataObjectParsed = [];
        if (dataObject) {
            dataObject.forEach((input1, index)=> {
                if (input1) {
                    input1.forEach((input2, index2)=>{
                        let object;
                        if (index === 0) {
                            object = {date: input2}
                            dataObjectParsed.push(object);
                        } else if (index === 1) {
                            Object.assign(dataObjectParsed[index2], {value: input2})
                        }
                    })
                    
                }
            })
        }
        return dataObjectParsed
    } 
   
    
    render() {
         const {showcomponent, epsilon, steps, emailAlert, spinningFlag, model, email} = this.state

         let alert;
         if (emailAlert) {
         alert =  <Publish model={model} email={email} onSubmit={this._onSubmit} urlPredict={this.props.urlPredict}/>
         } else {
         alert = <div></div>
         }


        let finalObjectFiltered = [];
        this.props.dataObject.forEach((input, index) => {
            if (this.props.positionFilter.indexOf(index) > -1) {
                finalObjectFiltered.push(input)
            }
        })
        
        const finalDataObject = this.parseObject(finalObjectFiltered)
        const finDataObjectPredict = this.parseObject(this.props.predictData)

        const epsilonFloat = parseFloat(epsilon)
        let component = (<div style={{width: "100%"}}>
                            <AnomalyDetection 
                                traindata={finalDataObject} 
                                predictdata={finDataObjectPredict} 
                                steps={steps} 
                                epsilon={epsilonFloat} 
                                publish={this._onpublish}
                                minperiod={"6hh"} />
                        </div>)
         
        return (
            <div>
                
                {alert}
                <h2><strong>Run Model</strong></h2>
                <div style={{top: "10px", right: "0"}}>
                <Box direction='row'
                        justify='center'
                        align='center'
                        wrap={true}
                        reverse={false}
                        margin='none'>
                        <Box direction='row'
                            align='center'
                            wrap={true}
                            pad='small'
                            margin='none'>
                            <Label>
                            {"Steps"}
                            </Label>
                            <Box direction='row'
                            align='center'
                            wrap={true}
                            pad='small'
                            margin='none'>
                                <NumberInput defaultValue={4} step={1} onChange={this._onChangeOptions.bind(this, 'steps')} />
                            </Box>
                        </Box>
                        <Box direction='row'
                            align='center'
                            wrap={true}
                            pad='small'
                            margin='none'>
                            <Label>
                            {"Epsilon"}
                            </Label>
                            <Box direction='row'
                            align='center'
                            wrap={true}
                            pad='small'
                            margin='none'>
                                <NumberInput defaultValue={0.01} step={0.01} onChange={this._onChangeOptions.bind(this, 'epsilon')} />
                            </Box>
                        </Box>
                </Box>
                </div>
                                
                 {(showcomponent) && component}
            
            </div>
        );
    }
}


export default Anomaly;



// WEBPACK FOOTER //
// ./src/samples/run/anomaly.js